import React, { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getMediaPath } from '../../app/functions';
import * as routes from '../../constants/routes';
import BreadCrumbs from '../../components/common/bread_crumbs';
import ImageHeader from '../../components/image-header';
import './about.scss';
import { useGetOurStoryQuery } from '../../redux/api/content.api';

const About = () => {
  const deviceState = useSelector(store => store.state.deviceState);
  const { data: ourStoryPageData } = useGetOurStoryQuery();
  const [ourStoryPage, setOurStoryPage] = useState(null);

  useEffect(() => {
    if (ourStoryPageData) {
      setOurStoryPage(ourStoryPageData);
    }
  }, [ourStoryPageData]);

  const getAllGoals = () => {
    const data = ourStoryPage.goals.values;
    return data.map((item, index) => (
      <div className="goal-wrapper" key={index}>
        <img className="goal-img" src={getMediaPath(item.imagePath)} alt="/"/>
        <span className="goal-title">{item.title}</span>
        <div className="para">{item.content}</div>
      </div>
    ));
  };

  const getAllTimeEvents = () => {
    const data = ourStoryPage.timeline.values;
    return data.map((item, index) => (
      <div key={index} className="time-event">
        <div className="line-container">
          <div className="white-dot"/>
        </div>

        <div className="event-container">
          <div className="event-year">
            {item.year}
          </div>

          <div className="event-content">
            {item.title}
          </div>
        </div>
      </div>
    ));
  };

  const isMobile = deviceState === 'mobile';
  const isLaptopOrDesktop = deviceState === 'desktop' || deviceState === 'desktop-large';
  const isTablet = deviceState === 'tablet';

  const areThereLogos = ourStoryPage
    && Array.isArray(ourStoryPage.ourStory.logos)
    && ourStoryPage.ourStory.logos.length > 0
    && ourStoryPage.ourStory.logos[0] !== '/_media/media//0.?t=';

  return (
    <section className="about">
      {ourStoryPage &&
        <Fragment>
          <ImageHeader
            title={ourStoryPage.ourStory.header.title}
            subtitle={ourStoryPage.ourStory.header.content}
            image={isMobile ? getMediaPath(ourStoryPage.ourStory.header.mobileImagePath) : getMediaPath(ourStoryPage.ourStory.header.imagePath)}
          />

          <BreadCrumbs root={{ text: 'דף הבית', route: routes.home }} className="about-crumbs"/>

          <div className="club-members" style={{background: isLaptopOrDesktop || isTablet ? "#f2f2f2" : "white" }}>
            <div className="detailimg-and-img">
              {isTablet || isLaptopOrDesktop &&
                <img className="club-img" src={getMediaPath(ourStoryPage.ourStory.body.imagePath)} alt="/"/>}
              <div className="detailing">
                <h3 className="title">{ourStoryPage.ourStory.body.title}</h3>
                <div className="detailing-para">{ourStoryPage.ourStory.body.content}</div>
              </div>
            </div>
            {areThereLogos && (
              <div className="logos-container">
                {ourStoryPage.ourStory.logos.map((item, index) => (
                  <div key={index} className="logo">
                    <img src={getMediaPath(item)} alt="/"/>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="our-goal">

            { isMobile && <div className="youtube-wrapper">
              <iframe width="560" height="315" src={ourStoryPage.ourStory.videoLink}
                      title="הסיפור שלנו"
                      frameBorder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      referrerPolicy="strict-origin-when-cross-origin"
                      />
            </div> }

            <div>
              <h3 className="title">{ourStoryPage.goals.title}</h3>
              <div className="goals-container">
                {getAllGoals()}
              </div>
            </div>

            { !isMobile &&
              (<div className="youtube-wrapper">
                <iframe width="560" height="315" src={ourStoryPage.ourStory.videoLink}
                        title="הסיפור שלנו"
                        frameBorder="0"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen/>
            </div>) }

          </div>

          <div className="time-line">
            <h3 className="title">{ourStoryPage.timeline.title}</h3>
            <div className="time-wrapper">
              <div className='gradient-timeline'>

              </div>
              {getAllTimeEvents()}
            </div>
          </div>
        </Fragment>
      }
    </section>
  );
};

export default About;
